module.exports = __webpack_public_path__ + "static/media/next-step-dot-icon.87d806cf.svg";